import { useCallback } from 'react';

import { useAppSelector } from '../../../app/hooks';

export type TypeUseTranslationHook = (key: string) => string;

export default function useTranslation(): TypeUseTranslationHook {
  const translations = useAppSelector((state) => state.translations.value);

  const t = useCallback(
    (key: string) => {
      if (key.includes('[') || key.includes(']')) {
        key = key.replaceAll('[', '');
        key = key.replaceAll(']', '');
      }

      if (Object.prototype.hasOwnProperty.call(translations, key)) {
        return translations[key];
      }

      return key;
    },

    [translations],
  );

  return t;
}
